import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { FadeInSection } from '@/components/ui/FadeInSection';

export function CTASection() {
  const { t, i18n } = useTranslation('home');
  const { locale } = useParams<{ locale: string }>();
  const currentLocale = locale || i18n.language || 'fr';
  return (
    <section className="py-12 bg-white">
      <FadeInSection>
        <div className="container mx-auto px-4 max-w-7xl text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-aspexit-black mb-6">
            {t('cta.title')}
          </h2>
          <p className="text-xl text-aspexit-gray mb-8 max-w-2xl mx-auto">
            {t('cta.subtitle')}
          </p>
          <Button asChild size="xl" variant="default">
            <Link to={`/${currentLocale}/contact`}>{t('cta.button')}</Link>
          </Button>
        </div>
      </FadeInSection>
    </section>
  );
}
